// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import visitCommitmentEntity from './entities/visit-commitment.json';
import visitCommitmentMenu from '../pages/visit-commitment/menu.json';
import visitCommitmentFullForm from '../pages/visit-commitment/forms/full.json';
import visitCommitmentContextForm from '../pages/visit-commitment/forms/context.json';
import visitCommitmentMiniForm from '../pages/visit-commitment/forms/mini.json';
import visitCommitmentLookupForm from '../pages/visit-commitment/forms/lookup.json';
import visitCommitmentTableView from '../pages/visit-commitment/views/table.json';
import visitCommitmentCardsView from '../pages/visit-commitment/views/cards.json';
import visitCommitmentCalendarView from '../pages/visit-commitment/views/calendar.json';
import visitCommitmentDashboardView from '../pages/visit-commitment/views/dashboard.json';

/** Тип запису «Зобов’язання» зі сторінками пакета: меню, форми та подання з pages/visit-commitment/. */
export const visitCommitmentDefinition: IRecordTypeDefinition = {
  ...visitCommitmentEntity,
  views: assembleViewSet({
      table: visitCommitmentTableView,
      cards: visitCommitmentCardsView,
      calendar: visitCommitmentCalendarView,
      dashboard: visitCommitmentDashboardView,
  }),
  form: visitCommitmentFullForm,
  forms: { full: visitCommitmentFullForm, context: visitCommitmentContextForm, mini: visitCommitmentMiniForm, lookup: visitCommitmentLookupForm },
  menu: visitCommitmentMenu,
} as IRecordTypeDefinition;
